// extracted by mini-css-extract-plugin
export var fileUpload = "_i8-1";
export var modalButton = "_i8-0";